import axios from 'axios';
import { baseUrl } from '@/config';

/**
 * basicinfo sub API
 * @author Ju
 */
export default {
  /**
   * basicinfoId에 대한 basicinfo sub 목록을 반환한다.
   * @author Ju
   * @param  {string} basicinfoId [basicinfoId]
   * @return {array}             basicinfo sub 배열
   */
  getList(basicinfoId) {
    return axios.get(`${baseUrl}/common/basicinfo/get-basicinfo-sub-list.do`, { params: { basicinfoId } });
  },
};



// WEBPACK FOOTER //
// ./src/api/model/basicinfo-sub.js